// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__81+gS","spinner":"SmallLoader_spinner__xQqKF","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__BKjkz"};